import React from 'react'
import { Link } from "react-router-dom"
import back from "../assets/images/icn_back.svg"
export function BackButton({ to, onClick, text }) {
    if (!onClick) {
        return (
            <Link to={to} onClick={onClick}>
                <img src={back} className="mb-1" /><span className=" color-text-dark-green ml-1">{text ? text : "Go Back"}</span>
            </Link>
        )
    } else {
        return (
            <div onClick={onClick} style={{ cursor: "pointer" }}>
                <img src={back} className="mb-1" /><span className=" color-text-dark-green ml-1">{text ? text : "Go Back"}</span>
            </div>
        )
    }
}
